import { Component, Prop, Vue } from "vue-property-decorator";
import { OutlineTop } from "./components/top/index";
import { ModuleList } from "./components/moduleList/index";
import { getUserCatalog } from "@/api/course";

@Component({
    components: {
        OutlineTop,
        ModuleList
    }
})
export default class MiddleOutline extends Vue {
    private courseId: number;
    private catalogList: any = {};
    private currentChapter: any = {};
    mounted() {
        this.courseId = Number(this.$route.params.courseId);
        this.getCatalog();
    }
    getCatalog() {
        getUserCatalog(this.courseId).then(res => {
            let list = res.data;
            this.catalogList = list;

            this.$set(this.currentChapter, "collapse", true);
            list.children.forEach((moduleItem: any) => {
                moduleItem.children.forEach((chapterItem: any, index: any) => {
                    if (chapterItem.placeStatus) {
                        this.$set(moduleItem, "moduleCollapse", true);
                        this.$set(chapterItem, "collapse", true);
                        this.currentChapter = chapterItem;
                    } else {
                        this.$set(chapterItem, "collapse", false);
                    }
                });
            });
        });
    }
}
